import "../../../NavbarV3/NavbarV3.css";
import DropdownConfig from "../DropdownConfig.tsx";
import DropdownDashboard from "../DropdownDashboard.tsx";
import DropdownEmbarques from "../DropdownEmbarques.tsx";
import DropdownPessoas from "../DropdownPessoas.tsx";
import DropdownPrecificacao from "../DropdownPrecificacao.tsx";
import DropdownRastreamento from "../DropdownRastreamento.tsx";
import DropdownUser from "../DropdownUser.tsx";
import {
	ConfigItemsEnum,
	DashboardItemsEnum,
	FinanceiroItemsEnum,
	GestaoItemsEnum,
	NavbarItemsEnum,
	NavbarRightItemsEnum,
	RastreamentoItemsEnum,
	UserItemsEnum,
	ViagemItemsEnum,
} from "../interfaces/Dropdown.enum.ts";
import {
	NavbarItemsInterface,
	NavbarSectionItems,
	RotaItem,
	RotaItemNavbarProps,
} from "../interfaces/Dropdown.interfaces.ts";

export const maisAcessadosItems: RotaItem[] = [
	{ label: "Viagens Todos", rota: "/viagens/todos", contextoEmbarque: "todos" },
	{ label: "Pedidos", rota: "/pedido" },
	{ label: "OnTime Todos", rota: "/ontime" },
	{ label: "Clientes", rota: "/cliente" },
	{ label: "Visualizar Faturamento", rota: "/faturamento" },
	{ label: "Viagens Frota", rota: "/viagens/frota", contextoEmbarque: "frota" },
	{ label: "Usuários", rota: "/cadastrar-usuario" },
];

export const viagemItems: RotaItem[] = [
	{
		label: "Modelo Viagens",
		rota: "/modelo-viagens",
		contextoEmbarque: "templateEmbarque",
	},
	{
		label: "Viagens Deletadas",
		rota: "/viagens-deletadas",
	},
	{
		label: "Viagens Finalizadas por Motorista",
		rota: "/viagens-finalizadas-motorista",
	},
	{ label: "Aguardando CTE", rota: "/aguardando-cte" },
];

export const pedidoItems: RotaItem[] = [
	{ label: "Gerenciamento de Pedido", rota: "/gerenciamento-pedido" },
	{ label: "Pedido", rota: "/pedido" },
];

export const diariaEmbarquesItems: RotaItem[] = [
	{ label: "Estadia", rota: "/estadia" },
];

export const prestacaoServicoItems: RotaItem[] = [
	{ label: "Contrato de Prestação de Serviço", rota: "/prestacao-servico" },
];

export const divergenciasSATItems: RotaItem[] = [
	{ label: "Divergências SAT", rota: "/divergencias-sat" },
];

export const logisticaDeTrafego: RotaItem[] = [
	{ label: "Localizador Veículos", rota: "/localizador-veiculos" },
	{ label: "Mesorregião", rota: "/mapa-meso" },
	{ label: "Disponibilidade Frota", rota: "/disponibilidade-frota" },
];

export const onTime: RotaItem[] = [
	{ label: "Todos", rota: "/ontime" },
	{ label: "Embarque", rota: "/ontime-embarque" },
	{ label: "Entrega", rota: "/ontime-entrega" },
];

export const gestaoPessoasItems: RotaItem[] = [
	{ label: "Clientes", rota: "/cliente" },
	{ label: "Grupo de Clientes", rota: "/grupo-clientes" },
	{ label: "Motoristas", rota: "/motorista" },
	{ label: "Proprietário", rota: "/proprietario" },
	{ label: "Vincular Clientes", rota: "/vincular-clientes" },
	{ label: "Solicitações de agregados", rota: "/solicitacoes-agregados" },
];

export const usuariosItems: RotaItem[] = [
	{ label: "Solicitações", rota: "/solicitacoes" },
	{ label: "Usuários", rota: "/cadastrar-usuario" },
];

export const gestaoVeiculosItems: RotaItem[] = [
	{ label: "Agenda", rota: "/diaria-veiculos" },
	{ label: "Caminhões", rota: "/caminhoes" },
	{ label: "Carretas", rota: "/carretas" },
	{ label: "Conjuntos", rota: "/conjuntos" },
	{ label: "Documentação", rota: "/documentacao" },
	{ label: "Grupo Cargas", rota: "/grupo-cargas" },
	{ label: "Vincular Grupo Cargas", rota: "/grupo-cargas-vinculo" },
];

export const checklistItems: RotaItem[] = [
	{ label: "Adicionar Checklist Veículo", rota: "/adicionar-check-veiculo" },
	{ label: "Checkagem", rota: "/checkagem" },
	{ label: "Checklist Frota", rota: "/frota" },
	{ label: "Tipo de Checkagem", rota: "/tipo-checkagem" },
	{ label: "Veículos Vencidos", rota: "/veiculos-vencidos" },
];

export const usoComumItems: RotaItem[] = [
	{ label: "Cidade", rota: "/cidade-estado" },
	{ label: "Embalagem", rota: "/embalagem" },
	{ label: "Empresas Subsidiárias", rota: "/empresa-sub" },
	{ label: "Filial", rota: "/filial" },
	{ label: "Meio Pagamento", rota: "/meio-pagamento" },
	{ label: "Mercadoria", rota: "/mercadoria" },
	{ label: "Motivo", rota: "/motivo" },
	{ label: "Motivo Cotação", rota: "/motivo-cotacao" },
	{ label: "Motivo Estadia", rota: "/motivo-estadia" },
	{ label: "Motivo On Time", rota: "/motivo-ontime" },
	{ label: "Ocorrência", rota: "/ocorrencia" },
	{ label: "Segmento Cliente", rota: "/segmento-cliente" },
	{ label: "Status", rota: "/status" },
	{ label: "Status Diária", rota: "/diaria-status" },
	{ label: "Sub Tipo Ocorrência", rota: "/tipo-ocorrencia" },
	{ label: "Taxa ICMS", rota: "/taxa-icms" },
	{ label: "Tipo Carroceria", rota: "/tipo-carroceria" },
	{ label: "Tipo Contato", rota: "/tipo-contato" },
	{ label: "Tipo Documento", rota: "/tipo-documento" },
	{ label: "Tipo Veículo", rota: "/tipo-veiculo" },
];

export const rastreamentoRotasItems: RotaItem[] = [
	{ label: "Cadastro Rastreio", rota: "/rastreamento" },
	{ label: "Tipo Rastreio", rota: "/tipo-rastreamento" },
];

export const rastreamentoItems: RotaItem[] = [
	{ label: "Visualizar Rotas", rota: "/rota" },
];

export const dashboardItems: RotaItem[] = [
	{ label: "Dashboard", rota: "/dashboard" },
	{ label: "Dashboard Cockpit", rota: "/dashboard-cockpit" },
	{ label: "Estatísticas Terceiros", rota: "/relatorio-proprietarios" },
	{ label: "Ocorrências", rota: "/dashboard-ocorrencias" },
	{ label: "Elegibilidade BRF", rota: "/elegebilidade-brf" },
	{ label: "Painel", rota: "/painel" },
	{ label: "Responsáveis", rota: "/responsaveis" },
	{ label: "Classificação de Pontos", rota: "/classificacao-pontos" },
];

export const indicadoresItems: RotaItem[] = [
	{
		label: "Indicador Faturamento Mensal",
		rota: "/indicador-faturamento-mensal",
	},
	{ label: "Meta Filial", rota: "/meta-filial" },
];

export const dashboardMobileItems: RotaItem[] = [
	{ label: "Dashboard", rota: "/dashboard" },
	{
		label: "Indicador Faturamento Mensal",
		rota: "/indicador-faturamento-mensal",
	},
	{ label: "Meta Filial", rota: "/meta-filial" },
];

export const precificacaoItems: RotaItem[] = [
	{ label: "Precificação", rota: "/precificacao" },
	{ label: "Grupo Precificação", rota: "/grupo-precificacao" },
];

export const cotacaoItems: RotaItem[] = [
	{ label: "Cotação", rota: "/cotacao" },
	{ label: "Dashboard Cotações", rota: "/dashboard-cotacao" },
];

export const faturamentoItems: RotaItem[] = [
	{ label: "Visualizar Faturamento", rota: "/faturamento" },
];

export const diariasItems: RotaItem[] = [
	{ label: "Diárias", rota: "/diarias" },
];

export const configItems: RotaItem[] = [
	{ label: "Alertas", rota: "/alertas" },
	{ label: "Avisos", rota: "/avisos" },
	{ label: "Colunas", rota: "/configuracoes-coluna" },
	{ label: "Cores", rota: "/configuracoes-cores" },
	{ label: "Enviar Email", rota: "/envia-email" },
	{ label: "Feedback", rota: "/feedback" },
	{ label: "Filiais", rota: "/filiais" },
	{ label: "Notificações", rota: "/notificacoes" },
	{ label: "Sorteio", rota: "/sorteio" },
];

export const userItems: RotaItem[] = [
	{ label: "Editar Usuário", rota: "/dados-usuario" },
	{ label: "Mudar Senha", rota: "/editar-usuario" },
];

export const ConfigSection: NavbarSectionItems = {
	[ConfigItemsEnum.CONFIG]: {
		titleSection: "Configurações",
		items: configItems,
		icon: "Bolt",
	},
};

export const UserSection: NavbarSectionItems = {
	[UserItemsEnum.USER]: {
		titleSection: "Usuário",
		items: userItems,
		icon: "User",
	},
};

export const maisAcessadosItemsSection: NavbarSectionItems = {
	["MAISACESSADOS"]: {
		titleSection: "Mais Acessados",
		items: maisAcessadosItems,
		icon: "Star",
	},
};

export const viagemItemsSection: NavbarSectionItems = {
	[ViagemItemsEnum.VIAGENS]: {
		titleSection: "Viagens",
		items: viagemItems,
		icon: "Truck",
	},
	[ViagemItemsEnum.PEDIDOS]: {
		titleSection: "Pedido",
		items: pedidoItems,
		icon: "ReceiptText",
	},
	[ViagemItemsEnum.DIARIAEMBARQUES]: {
		titleSection: "Diária",
		items: diariaEmbarquesItems,
		icon: "CalendarCheck2",
	},
	[ViagemItemsEnum.PRESTACAOSERVICO]: {
		titleSection: "Prestação de Serviço",
		items: prestacaoServicoItems,
		icon: "ClipboardList",
	},
	[ViagemItemsEnum.DIVERGENCIASSAT]: {
		titleSection: "Divergências SAT",
		items: divergenciasSATItems,
		icon: "TriangleAlert",
	},
	[ViagemItemsEnum.LOGISTICATRAFEGO]: {
		titleSection: "Logística de Tráfego",
		items: logisticaDeTrafego,
		icon: "Truck",
	},
	[ViagemItemsEnum.ON_TIME]: {
		titleSection: "On Time",
		items: onTime,
		icon: "Timer",
	},
};

export const gestaoItemsSection: NavbarSectionItems = {
	[GestaoItemsEnum.GESTAOPESSOAS]: {
		titleSection: "Pessoas",
		items: gestaoPessoasItems,
		icon: "Users",
	},
	[GestaoItemsEnum.USUARIOS]: {
		titleSection: "Usuários",
		items: usuariosItems,
		icon: "CircleUser",
	},
	[GestaoItemsEnum.GESTAOVEICULOS]: {
		titleSection: "Veículos",
		items: gestaoVeiculosItems,
		icon: "Car",
	},
	[GestaoItemsEnum.CHECKLIST]: {
		titleSection: "Checklist",
		items: checklistItems,
		icon: "ListCheck",
	},
	[GestaoItemsEnum.USOCOMUM]: {
		titleSection: "Uso Comum",
		items: usoComumItems,
		icon: "Boxes",
	},
};

export const RotasERastreioSection: NavbarSectionItems = {
	[RastreamentoItemsEnum.ROTAS]: {
		titleSection: "Rotas",
		items: rastreamentoItems,
		icon: "Map",
	},
	[RastreamentoItemsEnum.RASTREAMENTO]: {
		titleSection: "Rastreamento",
		items: rastreamentoRotasItems,
		icon: "LocateFixed",
	},
};

export const DashboardSection: NavbarSectionItems = {
	[DashboardItemsEnum.DASHBOARD]: {
		titleSection: "Dashboard",
		items: dashboardItems,
		icon: "ChartNoAxesCombined",
	},
	[DashboardItemsEnum.INDICADORES]: {
		titleSection: "Indicadores",
		items: indicadoresItems,
		icon: "GitGraph",
	},
};

export const DashboardMobileSection: NavbarSectionItems = {
	[DashboardItemsEnum.DASHBOARD]: {
		titleSection: "Dashboard",
		items: dashboardMobileItems,
		icon: "ChartNoAxesCombined",
	},
};

export const DiariasSection: NavbarSectionItems = {
	DIARIAS: {
		titleSection: "Diárias",
		items: diariasItems,
		icon: "CalendarCheck2",
	},
};

export const FinanceiroSection: NavbarSectionItems = {
	[FinanceiroItemsEnum.PRECIFICACAO]: {
		titleSection: "Precificação",
		items: precificacaoItems,
		icon: "Tags",
	},
	[FinanceiroItemsEnum.COTACAO]: {
		titleSection: "Cotação",
		items: cotacaoItems,
		icon: "ChartPie",
	},
	[FinanceiroItemsEnum.FATURAMENTO]: {
		titleSection: "Faturamento",
		items: faturamentoItems,
		icon: "CircleDollarSign",
	},
};

export const mostAccessedItemsSectionArray = Object.values(
	maisAcessadosItemsSection,
);
const viagemItemsSectionArray = Object.values(viagemItemsSection);
const gestaoItemsSectionArray = Object.values(gestaoItemsSection);
const RotasERastreioSectionArray = Object.values(RotasERastreioSection);
const DashboardSectionArray = Object.values(DashboardSection);
const DashboardMobileSectionArray = Object.values(DashboardMobileSection);
const FinanceiroSectionArray = Object.values(FinanceiroSection);
const ConfigSectionArray = Object.values(ConfigSection);
const UserSectionArray = Object.values(UserSection);

export const navbarSection = [
	...viagemItemsSectionArray,
	...RotasERastreioSectionArray,
	...gestaoItemsSectionArray,
	...DashboardSectionArray,
	...DashboardMobileSectionArray,
	...FinanceiroSectionArray,
	...ConfigSectionArray,
	...UserSectionArray,
];

export const ViagemEPedidosItems: RotaItemNavbarProps = {
	titleNavbar: "Viagem e Pedidos",
	icon: "Truck",
	sections: viagemItemsSection,
	dropdown: (props) => <DropdownEmbarques {...props} />,
};

export const RastreamentoItems: RotaItemNavbarProps = {
	titleNavbar: "Rotas e Rastreio",
	sections: RotasERastreioSection,
	dropdown: () => <DropdownRastreamento />,
};

export const GestaoItems: RotaItemNavbarProps = {
	titleNavbar: "Gestão",
	sections: gestaoItemsSection,
	dropdown: () => <DropdownPessoas />,
};

export const DashboardItems: RotaItemNavbarProps = {
	titleNavbar: "Dashboard",
	sections: DashboardSection,
	dropdown: () => <DropdownDashboard />,
};

export const DashboardMobileItems: RotaItemNavbarProps = {
	titleNavbar: "Dashboard",
	icon: "ChartNoAxesCombined",
	sections: DashboardMobileSection,
	dropdown: () => <DropdownDashboard />,
};

export const FinanceiroItems: RotaItemNavbarProps = {
	titleNavbar: "Financeiro",
	sections: FinanceiroSection,
	dropdown: () => <DropdownPrecificacao />,
};

export const DiariasItems: RotaItemNavbarProps = {
	titleNavbar: "Diárias",
	sections: DiariasSection,
	dropdown: () => <></>,
};

export const ConfigItems: RotaItemNavbarProps = {
	icon: "Settings",
	sections: ConfigSection,
	dropdown: () => <DropdownConfig />,
};

export const UserItems: RotaItemNavbarProps = {
	titleNavbar: "Usuário",
	icon: "User",
	sections: UserSection,
	dropdown: (props) => <DropdownUser {...props} />,
};

export const NavbarItems: NavbarItemsInterface = {
	[NavbarItemsEnum.VIAGEMEPEDIDOS]: ViagemEPedidosItems,
	[NavbarItemsEnum.RASTREAMENTO]: RastreamentoItems,
	[NavbarItemsEnum.GESTAOITEMS]: GestaoItems,
	[NavbarItemsEnum.DASHBOARD]: DashboardItems,
	[NavbarItemsEnum.FINANCEIRO]: FinanceiroItems,
};

export const NavbarItemsMobile: NavbarItemsInterface = {
	[NavbarItemsEnum.VIAGEMEPEDIDOS]: ViagemEPedidosItems,
	[NavbarItemsEnum.DASHBOARDMOBILE]: DashboardMobileItems,
};

export const NavbarRightItems: NavbarItemsInterface = {
	[NavbarRightItemsEnum.CONFIG]: ConfigItems,
	[NavbarRightItemsEnum.USER]: UserItems,
};
